import { useCallback, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dialog, DialogContent, Grid, Paper, Typography, Tooltip } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/VisibilityOutlined'
import CustomTable from '../../components/CustomTable/CustomTable'
import { getOrders } from '../../api/orders.service'
import { useDispatch, useSelector } from 'react-redux'
import { formatDate } from '../../common/utils'
import OrderDetails from './OrderDetails'
import { toggleModalFullscreen } from '../../redux/features/modalSlice'
import { events, pages, sections } from '../../common/activityLog'

const HistoryView = () => {
  const [selectedOrder, setSelectedOrder] = useState({})
  const [isModalDetailOpen, setIsModalDetailOpen] = useState(false)
  const [state, setState] = useState({
    data: [],
    columns: [],
    loading: false,
    pages: 0,
    page: 0,
    pageSize: 15,
    sorted: null,
    filtered: [],
    createModal: true,
    hasChanges: true
  })
  const providerSelected = useSelector((state) => state.provider)
  const modal = useSelector((state) => state.modal)
  const dispatch = useDispatch()

  const [tableLoading, setTableLoading] = useState(true)

  const handleSetState = (values) => {
    const newState = { ...state, ...values, hasChanges: true }
    setState(newState)
  }

  const getData = useCallback(
    (nState) => {
      if (nState) {
        nState = {
          ...nState,
          filtered: [
            ...nState.filtered,
            {
              id: 'state',
              value: 'Entregado'
            }
          ]
        }
      } else {
        nState = {
          ...state,
          filtered: [
            {
              id: 'state',
              value: 'Entregado'
            }
          ]
        }
      }
      setTableLoading(true)
      const postObject = {
        providerId: providerSelected.id,
        ...nState
      }
      const data = JSON.stringify(postObject)
      const headers = {
        sectionId: sections.Orders,
        pageId: pages.Delivery,
        eventId: events.DeliveryOrders
      }
      getOrders(data, headers)
        .then(({ data }) => {
          setState({
            ...state,
            page: postObject.page,
            sorted: postObject.sorted,
            filtered: postObject.filtered,
            pageSize: postObject.pageSize,
            data: data.results,
            pages: data.pageCount,
            hasChanges: false
          })
          setTableLoading(false)
        })
        .catch(function (error) {
          console.error(error)
        })
    },
    [providerSelected.id, state]
  )

  const generateColumns = useCallback(() => {
    setState({
      ...state,
      columns: [
        {
          Header: 'Nº Pedido',
          accessor: 'orderNumber',
          filterable: true,
          sortable: true,
          idSort: 'id',
          Cell: (props) => (
            <span style={{ float: 'right' }}>{`${props.value}/${props.row.original.level}`}</span>
          )
        },
        {
          Header: 'Fecha generacion pedido',
          accessor: 'orderDate',
          filterable: true,
          sortable: true,
          idSort: 'startDate',
          Cell: (props) => <span style={{ float: 'right' }}>{formatDate(props.value)}</span>
        },
        {
          Header: 'Fecha entrega planificada',
          accessor: 'orderDeliverEstimatedDate',
          filterable: true,
          sortable: true,
          idSort: 'startDate',
          Cell: (props) => <span style={{ float: 'right' }}>{formatDate(props.value)}</span>
        },
        {
          Header: 'Fecha recepción real',
          accessor: 'orderDeliverDate',
          filterable: true,
          sortable: true,
          idSort: 'startDate',
          Cell: (props) => <span style={{ float: 'right' }}>{formatDate(props.value)}</span>
        },
        {
          Header: 'Almacén de entrega',
          accessor: 'deliveryWarehouse',
          filterable: true,
          sortable: true,
          idSort: 'storage',
          Cell: (props) => <span style={{ float: 'right' }}>{props.value}</span>
        },
        {
          Header: '',
          accessor: 'details',
          sortable: false,
          Cell: (props) => (
            <span>
              <Tooltip title="Ver detalle del pedido">
                <VisibilityIcon
                  onClick={(e) =>
                    handleClickDetails(e, props.row.original.orderNumber, props.row.original.level)
                  }
                  height="25"
                  width="25"
                  style={{
                    cursor: 'pointer',
                    float: 'left',
                    marginLeft: '10px'
                  }}
                />
              </Tooltip>
            </span>
          ),
          width: 45
        }
      ]
    })
  }, [state])

  useEffect(() => {
    if (state.hasChanges && state.columns.length > 0) getData()
  }, [getData, state.hasChanges])

  useEffect(() => {
    if (Object.entries(state.columns).length === 0) generateColumns()
  }, [state.columns, generateColumns])

  const handleClickDetails = (e, orderNumber, level) => {
    setSelectedOrder({
      orderNumber: orderNumber,
      level: level
    })
    setIsModalDetailOpen(true)
  }

  const fetchData = (nState) => {
    getData(nState)
  }

  const handleCloseModalDetail = () => {
    getData()
    setIsModalDetailOpen(false)
  }

  const exitFullscreenModalDetail = useCallback(() => {
    if (!isModalDetailOpen && modal.showFullscreenOption) {
      dispatch(toggleModalFullscreen(false))
    }
  }, [isModalDetailOpen, modal.showFullscreenOption, dispatch])

  useEffect(() => {
    let timeout = setTimeout(exitFullscreenModalDetail, 500)
    return () => clearTimeout(timeout)
  }, [isModalDetailOpen, exitFullscreenModalDetail])

  return (
    <Paper style={{ padding: 16 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography color="secondary">PEDIDOS ENTREGADOS</Typography>
        </Grid>
        <Grid item xs={12}>
          {state.loading ? (
            <p>
              <em>Cargando...</em>
            </p>
          ) : (
            <CustomTable
              {...state}
              numButtonColumns={0}
              tableLoading={tableLoading}
              fetchData={fetchData}
              handleSetState={handleSetState}
              filterProps={[
                { placeholder: 'Filtrar Nº pedido...', id: 'id', value: '' },
                { width: 45, maxWidth: 45 },
                { width: 45, maxWidth: 45 },
                { width: 45, maxWidth: 45 },
                { placeholder: 'Filtrar almacen...', id: 'storage', value: '' },
                { width: 45, maxWidth: 45 }
              ]}
              manualSortBy={true}
            />
          )}
        </Grid>
      </Grid>
      <Dialog
        open={isModalDetailOpen}
        onClose={handleCloseModalDetail}
        maxWidth={'md'}
        fullWidth={true}
        fullScreen={modal.isFullscreen}
      >
        <DialogContent>
          <OrderDetails
            orderNumber={selectedOrder.orderNumber}
            level={selectedOrder.level}
            deliveryOrder={true}
            onClose={handleCloseModalDetail}
          />
        </DialogContent>
      </Dialog>
    </Paper>
  )
}

export default withRouter(HistoryView)
HistoryView.displayName = 'Pedidos entregados'
